import { AutogenModelRoutingGuideDetail, AutogenRowRoutingGuideDetail } from "./autogen/AutogenModelRoutingGuideDetail";

export class ModelRoutingGuideDetail extends AutogenModelRoutingGuideDetail<RowRoutingGuideDetail> {
    constructor() {
        super(RowRoutingGuideDetail);
    }
}

export class RowRoutingGuideDetail extends AutogenRowRoutingGuideDetail {
}